import endChime from '../assets/sound/ENDCHAIM.mp3';
import startChime from '../assets/sound/STARTCHAIM.mp3';

/**
 * 방송 시작음 / 종료음 URL 의 단일 출처.
 *
 * 과거에는 S3(itlogs3server) URL 을 직접 참조했다. S3 는 Origin 헤더가 실린 요청에만
 * Access-Control-Allow-Origin / Vary: Origin 을 응답하므로, crossOrigin 없이 받아온 응답이
 * HTTP 캐시에 남으면 뒤이은 relay 송출용 fetch(CORS 모드)가 그 캐시를 재사용하다
 * CORS 검증에 실패했다. 그 결과 로컬 재생만 되고 스피커로는 채임이 나가지 않았다.
 *
 * 앱과 동일 출처인 정적 자산으로 옮겨 CORS 검증 자체가 발생하지 않게 한다.
 * 번들러가 내용 해시를 붙이므로 음원을 교체하면 캐시도 자동으로 무효화된다.
 *
 * 같은 음원을 여러 곳에서 URL 로 각각 하드코딩하면 요청 모드가 갈려 캐시가 다시 오염되므로,
 * 차임 음원이 필요한 모든 코드는 반드시 이 모듈의 상수를 가져다 쓴다.
 */
export const START_CHAIM_AUDIO: string = startChime;
export const END_CHAIM_AUDIO: string = endChime;

/**
 * 채임 Audio 엘리먼트 생성 헬퍼.
 * 동일 출처 자산이라 CORS 검증은 일어나지 않지만, media element 요청과 relay 송출용 fetch 가
 * 같은 요청 모드로 같은 캐시 항목을 공유하도록 crossOrigin 을 유지한다.
 * 생성자에 URL 을 넘기면 crossOrigin 지정 전에 로딩이 시작되므로,
 * 반드시 crossOrigin 을 먼저 설정한 뒤 src 를 지정해야 한다.
 */
export const createChimeAudio = (url: string): HTMLAudioElement => {
  const audio = new Audio();
  audio.crossOrigin = 'anonymous';
  audio.src = url;
  return audio;
};
